import React from 'react';
import { connect } from 'react-redux';
import RenameFolderForm from 'components/event/FileSystem/RenameFolderForm';
import StyledModalHeader from 'components/modal/StyledModalHeader';
import StyledModalBody from 'components/modal/StyledModalBody';

import { updateFolder } from 'actions/Event';

import { UPDATE_FOLDER } from 'actions/Types';

import { clearModal } from 'actions';

import { Modal } from 'reactstrap';

const RenameFolderModal = (props) => {
  const {
    modalOpen,
    updateFolder,
    clearModal,
    existingName,
    existingDescription,
    parentPath,
  } = props;

  const clearFolderRenameModal = clearModal.bind(null, UPDATE_FOLDER);

  return (
    <Modal isOpen={modalOpen} toggle={clearFolderRenameModal}>
      <StyledModalHeader toggle={clearFolderRenameModal}>
        Edit folder settings
      </StyledModalHeader>
      <StyledModalBody>
        <RenameFolderForm
          existingName={existingName}
          existingDescription={existingDescription}
          onSubmit={(folderDetails) =>
            updateFolder({ ...folderDetails, parentPath })
          }
          onCancel={clearFolderRenameModal}
        />
      </StyledModalBody>
    </Modal>
  );
};

export default connect(
  ({ modal }) => {
    const props = {
      modalOpen: modal && modal.type === 'UPDATE_FOLDER',
    };

    if (props.modalOpen) {
      return { ...props, ...modal.initialValue };
    }

    return props;
  },
  {
    clearModal,
    updateFolder,
  },
)(RenameFolderModal);
